import * as t from 'io-ts';
import {GiftDynamicType} from 'acscp/api/models/gift';
import { GiftCategoryDynamicType } from 'acscp/api/models/giftCategory';

export const GiftsListDynamicType = t.interface({
    availableGifts: t.array(GiftDynamicType),
    balance: t.number,
    giftCategories: t.array(GiftCategoryDynamicType)
});

export type GiftsList = t.TypeOf<typeof GiftsListDynamicType>;
